import { request, getCompanyId } from '../utils'
import { API_GET_CHALLENGES_ANALYTICS, API_GET_DEMOGRAPHICS_ANALYTICS, API_GET_STEPS_ANALYTICS, GET_TEST_RESULTS_ANALYTICS,
         GET_BP_TEST_RESULTS, GET_CBC_TEST_RESULTS, GET_DIABETES_TEST_RESULTS, GET_KIDNEY_TEST_RESULTS, GET_THYROID_TEST_RESULTS,
         GET_LIPIDS_TEST_RESULTS, GET_LIVER_TEST_RESULTS, GET_URINE_EXAM_TEST_RESULTS, API_GET_LIFESTYLE,  API_GET_CONDITIONS,
         API_GET_STRESS_ANALYTICS, API_GET_SMOKING_ANALYTICS, API_GET_ALCOHOL_ANALYTICS, API_GET_DIET_ANALYTICS, API_GET_EXERCISE_ANALYTICS,
         API_GET_HYPERTENSIVE_ANALYTICS, API_GET_DIABETIC_ANALYTICS, API_GET_CVD_ANALYTICS, API_GET_WEIGHT_ANALYTICS, API_GET_METRIC_EAP_ANALYTICS,
         API_GET_LINE_GRA_EAP_ANALYTICS, API_GET_BAR_GRAPH_EAP_ANALYTICS, API_DOWNLOAD_HRA } from '../routes/api'

class analyticsApi {
  static getChallengesAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_CHALLENGES_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    )
  }
      
  static getDemographicsAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_DEMOGRAPHICS_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getStepsAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_STEPS_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    )
  }
    
  static getTestResultsAnalytics(options, onSuccess, onError) {
    const { contractId, startDate, endDate, companyId } = options
    return request(
      { url: GET_TEST_RESULTS_ANALYTICS(contractId, startDate, endDate, companyId), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getBpTestResults(options, onSuccess, onError) {
    const { contractId, startDate, endDate, companyId } = options
    return request(
      { url: GET_BP_TEST_RESULTS(contractId, startDate, endDate, companyId), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getCbcTestResults(options, onSuccess, onError) {
    const { contractId, startDate, endDate, companyId } = options
    return request(
      { url: GET_CBC_TEST_RESULTS(contractId, startDate, endDate, companyId), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getDiabetesTestResults(options, onSuccess, onError) {
    const { contractId, startDate, endDate, companyId } = options
    return request(
      { url: GET_DIABETES_TEST_RESULTS(contractId, startDate, endDate, companyId), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getKidneyTestResults(options, onSuccess, onError) {
    const { contractId, startDate, endDate, companyId } = options
    return request(
      { url: GET_KIDNEY_TEST_RESULTS(contractId, startDate, endDate, companyId), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getLipidsTestResults(options, onSuccess, onError) {
    const { contractId, startDate, endDate, companyId } = options
    return request(
      { url: GET_LIPIDS_TEST_RESULTS(contractId, startDate, endDate, companyId), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getLiverTestResults(options, onSuccess, onError) {
    const { contractId, startDate, endDate, companyId } = options
    return request(
      { url: GET_LIVER_TEST_RESULTS(contractId, startDate, endDate, companyId), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getThyroidTestResults(options, onSuccess, onError) {
    const { contractId, startDate, endDate, companyId } = options
    return request(
      { url: GET_THYROID_TEST_RESULTS(contractId, startDate, endDate, companyId), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getUrinExamTestResults(options, onSuccess, onError) {
    const { contractId, startDate, endDate, companyId } = options
    return request(
      { url: GET_URINE_EXAM_TEST_RESULTS(contractId, startDate, endDate, companyId), method: 'get', ...options },
      onSuccess,
      onError
    )
  }

  static getLifestyle(options, onSuccess, onError) {
    return request(
      { url: API_GET_LIFESTYLE(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getConditions(options, onSuccess, onError) {
    return request(
      { url: API_GET_CONDITIONS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getStressAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_STRESS_ANALYTICS(options.contractId, options.startDate, options.endDate)+ '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getSmokingAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_SMOKING_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getAlcoholAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_ALCOHOL_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getDietAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_DIET_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getExerciseAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_EXERCISE_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getHypertensiveAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_HYPERTENSIVE_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getDiabeticAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_DIABETIC_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getCVDAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_CVD_ANALYTICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getWeightAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_WEIGHT_ANALYTICS(options.contractId, options.startDate, options.endDate) +  '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static downloadHraReport(options, onSuccess, onError) {
    return request(
      { url: API_DOWNLOAD_HRA + '?' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getEAPAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_METRIC_EAP_ANALYTICS(options.contractId, options.startDate, options.endDate) +  '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getEAPLineDataAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_LINE_GRA_EAP_ANALYTICS(options.contractId, options.startDate, options.endDate) +  '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static getEAPBarDataAnalytics(options, onSuccess, onError) {
    return request(
      { url: API_GET_BAR_GRAPH_EAP_ANALYTICS(options.contractId, options.startDate, options.endDate) +  '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  
  // API_GET_BAR_GRAPH_EAP_ANALYTICS
}

export default analyticsApi
